// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__L5ecJ","modal":"Modal_modal__Nf4XE","slide-down":"Modal_slide-down__3qZJW"};